import html from "nanohtml";

type Event = {
  name: string;
  articleId?: string;
};

interface LinkProps {
  href: string;
  className?: string;
  logger: (event: Event) => void;
  articleId?: string;
  ariaLabel?: string;
  role?: string;
  tabIndex?: number;
}

function addUtmSource(url: string): string {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}page_source=v_recirc`;
}

export function Link(props: LinkProps, children: HTMLElement): HTMLElement {
  const { 
    href, 
    className = "", 
    logger, 
    articleId,
    ariaLabel,
    role,
    tabIndex 
  } = props;

  const enhancedHref = addUtmSource(href);

  const handleClick = () => {
    logger({
      name: "article_click",
      articleId,
    });
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    // Handle Enter and Space keys for accessibility
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleClick();
      // Navigate to the link
      window.location.href = enhancedHref;
    }
  };

  const linkElement = html`
    <a 
      href="${enhancedHref}" 
      class="${className}"
    >
      ${children}
    </a>
  `;

  // Set attributes properly after creation
  if (ariaLabel) {
    linkElement.setAttribute('aria-label', ariaLabel);
  }
  if (role) {
    linkElement.setAttribute('role', role);
  }
  if (tabIndex !== undefined) {
    linkElement.setAttribute('tabindex', String(tabIndex));
  }

  // Add event listeners
  linkElement.addEventListener("click", handleClick);
  linkElement.addEventListener("keydown", handleKeyDown);

  return linkElement;
}
